import { render, staticRenderFns } from "./setSecretQuestion.vue?vue&type=template&id=1035ad5c&scoped=true&"
import script from "./setSecretQuestion.vue?vue&type=script&lang=ts&"
export * from "./setSecretQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./setSecretQuestion.vue?vue&type=style&index=0&id=1035ad5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1035ad5c",
  null
  
)

export default component.exports